import { createQueryKeys } from '@lukemorales/query-key-factory'

import { cartService } from '@/domain/Cart'
import { GetCartDto } from '@/domain/Cart/dtos/get-cart.dto'

export const cart = createQueryKeys('cart', {
    getCart: (dto: GetCartDto) => ({
        queryKey: ['currentCart', dto.cart_id],
        queryFn: () => cartService.getCartById(dto),
    }),
    listShippingOptionsByCart: (cart_id: string) => ({
        queryKey: ['shipping', 'listByCart', cart_id],
        queryFn: () => cartService.listShippingOptionsByCart({ cart_id }),
    }),
})
